// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file backtest.proto (package cryptotrader, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file backtest.proto.
 */
export const file_backtest: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message cryptotrader.BacktestResult
 */
export type BacktestResult = Message<"cryptotrader.BacktestResult"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: string timeframe = 2;
   */
  timeframe: string;

  /**
   * @generated from field: string engine_type = 3;
   */
  engineType: string;

  /**
   * @generated from field: double initial_fiat = 4;
   */
  initialFiat: number;

  /**
   * @generated from field: double fee_rate = 5;
   */
  feeRate: number;

  /**
   * @generated from field: string default_qty = 6;
   */
  defaultQty: string;

  /**
   * @generated from field: repeated cryptotrader.BacktestTrade trades = 8;
   */
  trades: BacktestTrade[];

  /**
   * @generated from field: repeated double equity_curve = 9;
   */
  equityCurve: number[];

  /**
   * @generated from field: double fiat_start = 10;
   */
  fiatStart: number;

  /**
   * @generated from field: double fiat_end = 11;
   */
  fiatEnd: number;

  /**
   * @generated from field: double crypto_start = 12;
   */
  cryptoStart: number;

  /**
   * @generated from field: double crypto_end = 13;
   */
  cryptoEnd: number;

  /**
   * @generated from field: double estimated_start_fiat = 14;
   */
  estimatedStartFiat: number;

  /**
   * @generated from field: double estimated_end_fiat = 15;
   */
  estimatedEndFiat: number;

  /**
   * last candle close (for open position valuation)
   *
   * @generated from field: double last_close = 16;
   */
  lastClose: number;

  /**
   * last candle open time (RFC3339)
   *
   * @generated from field: string last_date = 17;
   */
  lastDate: string;

  /**
   * @generated from field: string warning = 18;
   */
  warning: string;

  /**
   * fetch start, start_date minus warmup bars (RFC3339)
   *
   * @generated from field: string requested_first_date = 19;
   */
  requestedFirstDate: string;

  /**
   * first candle open time returned; empty = no data
   *
   * @generated from field: string actual_first_date = 20;
   */
  actualFirstDate: string;

  /**
   * @generated from field: cryptotrader.PreviewStats stats = 22;
   */
  stats?: PreviewStats | undefined;

  /**
   * @generated from field: cryptotrader.PreviewOutputs outputs = 23;
   */
  outputs?: PreviewOutputs | undefined;

  /**
   * Additional preview statistics, analyses and outputs
   *
   * @generated from field: cryptotrader.PreviewDetails preview = 21;
   */
  preview?: PreviewDetails | undefined;
};

/**
 * Describes the message cryptotrader.BacktestResult.
 * Use `create(BacktestResultSchema)` to create a new message.
 */
export const BacktestResultSchema: GenMessage<BacktestResult> = /*@__PURE__*/
  messageDesc(file_backtest, 0);

/**
 * @generated from message cryptotrader.BacktestTrade
 */
export type BacktestTrade = Message<"cryptotrader.BacktestTrade"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * "BUY" or "SELL"
   *
   * @generated from field: string action = 2;
   */
  action: string;

  /**
   * RFC3339
   *
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * @generated from field: double price = 4;
   */
  price: number;

  /**
   * @generated from field: double crypto = 5;
   */
  crypto: number;

  /**
   * @generated from field: double fiat = 6;
   */
  fiat: number;

  /**
   * @generated from field: double fee = 7;
   */
  fee: number;

  /**
   * @generated from field: string comment = 8;
   */
  comment: string;

  /**
   * "long", "short", "buy", "sell"
   *
   * @generated from field: string direction = 9;
   */
  direction: string;

  /**
   * @generated from field: double pnl = 10;
   */
  pnl: number;

  /**
   * @generated from field: double cum_pnl = 11;
   */
  cumPnl: number;

  /**
   * fill bar close time, RFC3339; empty when unknown
   *
   * @generated from field: string date_close = 12;
   */
  dateClose: string;
};

/**
 * Describes the message cryptotrader.BacktestTrade.
 * Use `create(BacktestTradeSchema)` to create a new message.
 */
export const BacktestTradeSchema: GenMessage<BacktestTrade> = /*@__PURE__*/
  messageDesc(file_backtest, 1);

/**
 * @generated from message cryptotrader.PreviewRun
 */
export type PreviewRun = Message<"cryptotrader.PreviewRun"> & {
  /**
   * @generated from field: string symbol = 1;
   */
  symbol: string;

  /**
   * @generated from field: string timeframe = 2;
   */
  timeframe: string;

  /**
   * @generated from field: string engine_type = 3;
   */
  engineType: string;

  /**
   * @generated from field: double initial_fiat = 4;
   */
  initialFiat: number;

  /**
   * @generated from field: double fee_rate = 5;
   */
  feeRate: number;

  /**
   * @generated from field: string fee_unit = 6;
   */
  feeUnit: string;

  /**
   * @generated from field: string default_qty = 7;
   */
  defaultQty: string;

  /**
   * @generated from field: string requested_first_date = 8;
   */
  requestedFirstDate: string;

  /**
   * @generated from field: string actual_first_date = 9;
   */
  actualFirstDate: string;

  /**
   * @generated from field: string last_date = 10;
   */
  lastDate: string;

  /**
   * @generated from field: string recalculate = 11;
   */
  recalculate: string;

  /**
   * @generated from field: int64 margin_calls = 12;
   */
  marginCalls: bigint;
};

/**
 * Describes the message cryptotrader.PreviewRun.
 * Use `create(PreviewRunSchema)` to create a new message.
 */
export const PreviewRunSchema: GenMessage<PreviewRun> = /*@__PURE__*/
  messageDesc(file_backtest, 2);

/**
 * @generated from message cryptotrader.PreviewCapital
 */
export type PreviewCapital = Message<"cryptotrader.PreviewCapital"> & {
  /**
   * @generated from field: double fiat_start = 1;
   */
  fiatStart: number;

  /**
   * @generated from field: double fiat_end = 2;
   */
  fiatEnd: number;

  /**
   * @generated from field: double crypto_start = 3;
   */
  cryptoStart: number;

  /**
   * @generated from field: double crypto_end = 4;
   */
  cryptoEnd: number;

  /**
   * @generated from field: double estimated_start_fiat = 5;
   */
  estimatedStartFiat: number;

  /**
   * @generated from field: double estimated_end_fiat = 6;
   */
  estimatedEndFiat: number;

  /**
   * @generated from field: double last_close = 7;
   */
  lastClose: number;
};

/**
 * Describes the message cryptotrader.PreviewCapital.
 * Use `create(PreviewCapitalSchema)` to create a new message.
 */
export const PreviewCapitalSchema: GenMessage<PreviewCapital> = /*@__PURE__*/
  messageDesc(file_backtest, 3);

/**
 * @generated from message cryptotrader.PreviewTradeStats
 */
export type PreviewTradeStats = Message<"cryptotrader.PreviewTradeStats"> & {
  /**
   * @generated from field: int64 total = 1;
   */
  total: bigint;

  /**
   * @generated from field: int64 winning = 2;
   */
  winning: bigint;

  /**
   * @generated from field: int64 losing = 3;
   */
  losing: bigint;

  /**
   * @generated from field: double win_rate = 4;
   */
  winRate: number;

  /**
   * @generated from field: double avg_win = 5;
   */
  avgWin: number;

  /**
   * @generated from field: double avg_loss = 6;
   */
  avgLoss: number;

  /**
   * @generated from field: int64 max_consecutive_wins = 7;
   */
  maxConsecutiveWins: bigint;

  /**
   * @generated from field: int64 max_consecutive_losses = 8;
   */
  maxConsecutiveLosses: bigint;

  /**
   * @generated from field: double avg_duration_s = 9;
   */
  avgDurationS: number;
};

/**
 * Describes the message cryptotrader.PreviewTradeStats.
 * Use `create(PreviewTradeStatsSchema)` to create a new message.
 */
export const PreviewTradeStatsSchema: GenMessage<PreviewTradeStats> = /*@__PURE__*/
  messageDesc(file_backtest, 4);

/**
 * @generated from message cryptotrader.PreviewStats
 */
export type PreviewStats = Message<"cryptotrader.PreviewStats"> & {
  /**
   * @generated from field: double net_profit = 1;
   */
  netProfit: number;

  /**
   * @generated from field: double profit_pct = 2;
   */
  profitPct: number;

  /**
   * @generated from field: double profit_factor = 3;
   */
  profitFactor: number;

  /**
   * @generated from field: double max_drawdown = 4;
   */
  maxDrawdown: number;

  /**
   * @generated from field: double max_drawdown_pct = 5;
   */
  maxDrawdownPct: number;

  /**
   * @generated from field: double sharpe_ratio = 6;
   */
  sharpeRatio: number;

  /**
   * @generated from field: double sortino_ratio = 7;
   */
  sortinoRatio: number;

  /**
   * @generated from field: cryptotrader.PreviewTradeStats trades = 8;
   */
  trades?: PreviewTradeStats | undefined;
};

/**
 * Describes the message cryptotrader.PreviewStats.
 * Use `create(PreviewStatsSchema)` to create a new message.
 */
export const PreviewStatsSchema: GenMessage<PreviewStats> = /*@__PURE__*/
  messageDesc(file_backtest, 5);

/**
 * @generated from message cryptotrader.PreviewTiming
 */
export type PreviewTiming = Message<"cryptotrader.PreviewTiming"> & {
  /**
   * @generated from field: double build_ms = 1;
   */
  buildMs: number;

  /**
   * @generated from field: double fetch_ms = 2;
   */
  fetchMs: number;

  /**
   * @generated from field: double feed_ms = 3;
   */
  feedMs: number;

  /**
   * @generated from field: double engine_ms = 4;
   */
  engineMs: number;

  /**
   * @generated from field: double total_ms = 5;
   */
  totalMs: number;

  /**
   * @generated from field: int64 bars = 6;
   */
  bars: bigint;
};

/**
 * Describes the message cryptotrader.PreviewTiming.
 * Use `create(PreviewTimingSchema)` to create a new message.
 */
export const PreviewTimingSchema: GenMessage<PreviewTiming> = /*@__PURE__*/
  messageDesc(file_backtest, 6);

/**
 * @generated from message cryptotrader.PreviewMonteCarlo
 */
export type PreviewMonteCarlo = Message<"cryptotrader.PreviewMonteCarlo"> & {
  /**
   * @generated from field: int64 iterations = 1;
   */
  iterations: bigint;

  /**
   * @generated from field: double risk_of_ruin_pct = 2;
   */
  riskOfRuinPct: number;

  /**
   * @generated from field: map<string, double> max_dd_percentiles = 3;
   */
  maxDdPercentiles: { [key: string]: number };

  /**
   * @generated from field: double actual_max_dd_pct = 4;
   */
  actualMaxDdPct: number;

  /**
   * @generated from field: bool is_fragile = 5;
   */
  isFragile: boolean;
};

/**
 * Describes the message cryptotrader.PreviewMonteCarlo.
 * Use `create(PreviewMonteCarloSchema)` to create a new message.
 */
export const PreviewMonteCarloSchema: GenMessage<PreviewMonteCarlo> = /*@__PURE__*/
  messageDesc(file_backtest, 7);

/**
 * @generated from message cryptotrader.PreviewSignificance
 */
export type PreviewSignificance = Message<"cryptotrader.PreviewSignificance"> & {
  /**
   * @generated from field: int64 iterations = 1;
   */
  iterations: bigint;

  /**
   * @generated from field: double p_value = 2;
   */
  pValue: number;

  /**
   * @generated from field: double percentile = 3;
   */
  percentile: number;

  /**
   * @generated from field: bool significant = 4;
   */
  significant: boolean;

  /**
   * @generated from field: int64 n_signals = 5;
   */
  nSignals: bigint;

  /**
   * @generated from field: int64 n_bars = 6;
   */
  nBars: bigint;
};

/**
 * Describes the message cryptotrader.PreviewSignificance.
 * Use `create(PreviewSignificanceSchema)` to create a new message.
 */
export const PreviewSignificanceSchema: GenMessage<PreviewSignificance> = /*@__PURE__*/
  messageDesc(file_backtest, 8);

/**
 * @generated from message cryptotrader.PreviewClosedTrade
 */
export type PreviewClosedTrade = Message<"cryptotrader.PreviewClosedTrade"> & {
  /**
   * @generated from field: string direction = 1;
   */
  direction: string;

  /**
   * @generated from field: string entry_date = 2;
   */
  entryDate: string;

  /**
   * @generated from field: string exit_date = 3;
   */
  exitDate: string;

  /**
   * @generated from field: string entry_date_close = 4;
   */
  entryDateClose: string;

  /**
   * @generated from field: string exit_date_close = 5;
   */
  exitDateClose: string;

  /**
   * @generated from field: double entry_price = 6;
   */
  entryPrice: number;

  /**
   * @generated from field: double exit_price = 7;
   */
  exitPrice: number;

  /**
   * @generated from field: double qty = 8;
   */
  qty: number;

  /**
   * @generated from field: double pnl = 9;
   */
  pnl: number;

  /**
   * @generated from field: double pnl_pct = 10;
   */
  pnlPct: number;

  /**
   * @generated from field: double fee = 11;
   */
  fee: number;

  /**
   * @generated from field: double commission = 12;
   */
  commission: number;

  /**
   * @generated from field: string comment = 13;
   */
  comment: string;

  /**
   * @generated from field: int64 bars = 14;
   */
  bars: bigint;

  /**
   * @generated from field: bool is_open = 15;
   */
  isOpen: boolean;
};

/**
 * Describes the message cryptotrader.PreviewClosedTrade.
 * Use `create(PreviewClosedTradeSchema)` to create a new message.
 */
export const PreviewClosedTradeSchema: GenMessage<PreviewClosedTrade> = /*@__PURE__*/
  messageDesc(file_backtest, 9);

/**
 * @generated from message cryptotrader.PreviewDetails
 */
export type PreviewDetails = Message<"cryptotrader.PreviewDetails"> & {
  /**
   * @generated from field: cryptotrader.PreviewRun run = 1;
   */
  run?: PreviewRun | undefined;

  /**
   * @generated from field: cryptotrader.PreviewCapital capital = 2;
   */
  capital?: PreviewCapital | undefined;

  /**
   * @generated from field: cryptotrader.PreviewStats stats = 3;
   */
  stats?: PreviewStats | undefined;

  /**
   * @generated from field: repeated cryptotrader.PreviewClosedTrade closed_trades = 4;
   */
  closedTrades: PreviewClosedTrade[];

  /**
   * @generated from field: cryptotrader.PreviewOutputs outputs = 5;
   */
  outputs?: PreviewOutputs | undefined;

  /**
   * @generated from field: cryptotrader.PreviewTiming timing = 6;
   */
  timing?: PreviewTiming | undefined;

  /**
   * @generated from field: cryptotrader.PreviewMonteCarlo monte_carlo = 7;
   */
  monteCarlo?: PreviewMonteCarlo | undefined;

  /**
   * @generated from field: cryptotrader.PreviewSignificance significance = 8;
   */
  significance?: PreviewSignificance | undefined;

  /**
   * @generated from field: repeated string warnings = 9;
   */
  warnings: string[];
};

/**
 * Describes the message cryptotrader.PreviewDetails.
 * Use `create(PreviewDetailsSchema)` to create a new message.
 */
export const PreviewDetailsSchema: GenMessage<PreviewDetails> = /*@__PURE__*/
  messageDesc(file_backtest, 10);

/**
 * @generated from message cryptotrader.PreviewOutputs
 */
export type PreviewOutputs = Message<"cryptotrader.PreviewOutputs"> & {
  /**
   * @generated from field: string time = 1;
   */
  time: string;

  /**
   * @generated from field: repeated cryptotrader.PreviewAlert alerts = 2;
   */
  alerts: PreviewAlert[];

  /**
   * @generated from field: repeated cryptotrader.PreviewPlot plots = 3;
   */
  plots: PreviewPlot[];
};

/**
 * Describes the message cryptotrader.PreviewOutputs.
 * Use `create(PreviewOutputsSchema)` to create a new message.
 */
export const PreviewOutputsSchema: GenMessage<PreviewOutputs> = /*@__PURE__*/
  messageDesc(file_backtest, 11);

/**
 * @generated from message cryptotrader.PreviewAlert
 */
export type PreviewAlert = Message<"cryptotrader.PreviewAlert"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: bool value = 3;
   */
  value: boolean;
};

/**
 * Describes the message cryptotrader.PreviewAlert.
 * Use `create(PreviewAlertSchema)` to create a new message.
 */
export const PreviewAlertSchema: GenMessage<PreviewAlert> = /*@__PURE__*/
  messageDesc(file_backtest, 12);

/**
 * @generated from message cryptotrader.PreviewPlot
 */
export type PreviewPlot = Message<"cryptotrader.PreviewPlot"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: optional double value = 2;
   */
  value?: number | undefined;
};

/**
 * Describes the message cryptotrader.PreviewPlot.
 * Use `create(PreviewPlotSchema)` to create a new message.
 */
export const PreviewPlotSchema: GenMessage<PreviewPlot> = /*@__PURE__*/
  messageDesc(file_backtest, 13);

